/**
 * Service worker registration.
 *
 * Only registers in production builds (NODE_ENV === "production") so the
 * dev-server's HMR isn't shadowed by a stale cache. Listens for new SW
 * installations and prompts the page to refresh once a fresh worker is
 * ready (the user gets the latest version on their next interaction).
 */

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Auto-detect updates: when a new worker is installed, ping it to
        // skip waiting so it activates on the next navigation.
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              // A new SW is ready — activate it immediately.
              sw.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((err) => {
        // Non-fatal: app still works without the SW.
        console.warn("[SW] Registration failed:", err);
      });

    // Reload once the new SW takes over so cached assets pick up the new bundle.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
